
import {
  FETCH_PERIODS_FAILURE, FETCH_PERIODS_REQUEST, FETCH_PERIODS_SUCCESS,
  ADD_PERIOD_FAILURE, ADD_PERIOD_REQUEST, ADD_PERIOD_SUCCESS,
  DELETE_PERIOD_FAILURE, DELETE_PERIOD_REQUEST, DELETE_PERIOD_SUCCESS,
  UPDATE_PERIOD_FAILURE, UPDATE_PERIOD_REQUEST, UPDATE_PERIOD_SUCCESS
} from "../actions/RentalPeriodAction";
import {formatDateToAPP} from "../../utils/tools";


// État initial
const initialState = {
  periods: [],
  loading: false,
  error: null
};

// Reducer
const reducer = (state = initialState, action) => {
  switch (action.type) {
    // FETCH
    case FETCH_PERIODS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_PERIODS_SUCCESS:
      const periods = [...action.payload].map(period => ({
        ...period,
        start_at: formatDateToAPP(period.start_at),
        end_at: formatDateToAPP(period.end_at)
      }))
      return {
        ...state,
        loading: false,
        periods: periods
      };
    case FETCH_PERIODS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // ADD
    case ADD_PERIOD_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case ADD_PERIOD_SUCCESS:
      return {
        ...state,
        loading: false,
        periods: [...state.periods, {
          ...action.payload,
          start_at: formatDateToAPP(action.payload.start_at),
          end_at: formatDateToAPP(action.payload.end_at)
        }]
      };
    case ADD_PERIOD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // UPDATE
    case UPDATE_PERIOD_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case UPDATE_PERIOD_SUCCESS:
      return {
        ...state,
        loading: false,
        periods: state.periods.map(period =>
          period.id === action.payload.id ? {
            ...action.payload,
            start_at: formatDateToAPP(action.payload.start_at),
            end_at: formatDateToAPP(action.payload.end_at)
          } : period
        )
      };
    case UPDATE_PERIOD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // DELETE
    case DELETE_PERIOD_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case DELETE_PERIOD_SUCCESS:
      return {
        ...state,
        loading: false,
        periods: state.periods.filter(period => period.id !== action.payload)
      };
    case DELETE_PERIOD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
};

export default reducer;